var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mt-4"},[_c('div',{staticClass:"card col-12"},[_c('div',{staticClass:"mt-4"},[_c('supply-rule-widget-table',{attrs:{"is-widget":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }